(function() { window.GUID_3d21ecc6_a487_4a68_bdf5_047adad36034 = { getGuid: function() { return "3d21ecc6-a487-4a68-bdf5-047adad36034"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        var ImageCropperAddons;
        (function (ImageCropperAddons) {
            class Base {
                constructor(mainHelper) {
                    this.mainHelper = mainHelper;
                    this.disposed = false;
                }
                Dispose() {
                    if (!this.disposed) {
                        this.disposed = true;
                        this.OnDispose();
                        this.disposed = false;
                    }
                }
            }
            ImageCropperAddons.Base = Base;
        })(ImageCropperAddons = Controls.ImageCropperAddons || (Controls.ImageCropperAddons = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=base-image-cropper-addons.js.map
